import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import fileSize from 'filesize';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { T } from '../i18n';
export const ImageSizeHelper = ({ recommendedWidth, recommendedHeight, showSizeLimit = true, }) => {
    var _a;
    const { data: network } = useNetwork();
    return (_jsxs(_Fragment, { children: [recommendedWidth > 0 && recommendedHeight > 0 && (_jsx("p", { children: _jsx(T, { defaultMessage: "Recommended size is {width, number} x {height, number} pixels.", id: "Generics.RecommendedImageSize", values: {
                        width: recommendedWidth,
                        height: recommendedHeight,
                    } }, void 0) }, void 0)), showSizeLimit && (_jsx("p", { children: _jsx(T, { id: "Generics.FileSizeLimit", defaultMessage: "The file size limit is {size_limit}.", values: {
                        size_limit: fileSize(((_a = network === null || network === void 0 ? void 0 : network.settings) === null || _a === void 0 ? void 0 : _a.imageSizeLimit) || 10000, {
                            spacer: '',
                        }),
                    } }, void 0) }, void 0))] }, void 0));
};
//# sourceMappingURL=ImageSizeHelper.js.map